/* TLC: colour squares on cards + inside the quick shop drawer.
   Card squares are spans with data-url (so the wishlist app sees one product link per card):
   tapping one opens that colour. In the drawer, tapping one swaps the drawer to that colour.
   Final sale colours (tag 'finalsale') show a no-returns note above Add to cart.
   In the drawer, sale colours (data-sale: marked down or final sale) get their own
   "On Sale" row under the full price colours, when a style has both. */
(function(){
  if (window.__tlcQsColours) return; window.__tlcQsColours = true;
  var lastCard = null, cache = {};
  function money(c){ return '$' + (c/100).toFixed(2); }
  function img(u){ if(!u) return ''; if(u.indexOf('//')===0) u='https:'+u; return u + (u.indexOf('?')>-1?'&':'?') + 'width=200&height=250&crop=center'; }
  function box(){
    var b = document.getElementById('tlc-qs-colours');
    if (!b) {
      var sizes = document.querySelector('#tlc-qs-drawer .tlc-qs-size-row');
      if (!sizes) return null;
      b = document.createElement('div'); b.id = 'tlc-qs-colours';
      b.innerHTML = '<div class="tlc-qsc-label">Colour <span></span></div><div class="tlc-qsc-row"></div>';
      sizes.parentNode.insertBefore(b, sizes);
    }
    if (!b.querySelector('.tlc-qsc-sale')) {
      var s = document.createElement('div'); s.className = 'tlc-qsc-sale'; s.hidden = true;
      s.innerHTML = '<div class="tlc-qsc-label tlc-qsc-label--sale">On Sale</div><div class="tlc-qsc-row tlc-qsc-row--sale"></div>';
      b.appendChild(s);
    }
    return b;
  }
  function finalNote(on){
    var n = document.getElementById('tlc-qs-final');
    if (!n) {
      var actions = document.querySelector('#tlc-qs-drawer .tlc-qs-actions');
      if (!actions) return;
      n = document.createElement('div'); n.id = 'tlc-qs-final'; n.setAttribute('role', 'note');
      n.innerHTML = 'Final sale<span>No returns on final sale items.</span>';
      actions.parentNode.insertBefore(n, actions);
    }
    n.classList.toggle('is-on', !!on);
  }
  function fill(card, currentUrl){
    var b = box(); if (!b) return;
    var src = card && card.querySelector('.tcs');
    if (!src) { b.style.display = 'none'; return; }
    b.style.display = '';
    var row = b.querySelector('.tlc-qsc-row:not(.tlc-qsc-row--sale)'); row.innerHTML = '';
    var saleWrap = b.querySelector('.tlc-qsc-sale');
    var saleRow = saleWrap.querySelector('.tlc-qsc-row--sale'); saleRow.innerHTML = '';
    var all = [];
    src.querySelectorAll('.tcs__s').forEach(function(s){
      var n = document.createElement('button'); n.type = 'button'; n.className = 'tcs__s';
      n.innerHTML = s.innerHTML; n.title = s.title;
      n.dataset.url = s.dataset.url || '';
      if (s.dataset.final) n.dataset.final = '1';
      if (s.dataset.sale) n.dataset.sale = '1';
      n.setAttribute('aria-label', s.title + (s.dataset.final ? ' (final sale)' : ''));
      if (n.dataset.url === currentUrl) n.classList.add('is-on');
      all.push(n);
    });
    var sale = all.filter(function(n){ return n.dataset.sale; });
    var split = sale.length > 0 && sale.length < all.length;
    all.forEach(function(n){ (split && n.dataset.sale ? saleRow : row).appendChild(n); });
    saleWrap.hidden = !split;
    var on = b.querySelector('.tcs__s.is-on');
    b.querySelector('.tlc-qsc-label span').textContent = on ? on.title : '';
  }
  function swap(s){
    var url = s.dataset.url;
    function apply(p){
      var fake = { dataset: {
        productTitle: p.title, productPrice: money(p.price), productUrl: url,
        productImage: img(p.featured_image), variants: JSON.stringify(p.variants.map(function(v){ return { id: v.id, title: v.title, available: v.available }; })),
        fitNote: (document.getElementById('tlc-qs-fit') || {}).textContent || ''
      }};
      window.TLCQuickShop.open(fake);
      fill(lastCard, url);
      var tags = (p.tags || []).map(function(t){ return String(t).toLowerCase(); });
      finalNote(tags.indexOf('finalsale') > -1 || !!s.dataset.final);
    }
    s.style.opacity = '.5';
    if (cache[url]) return apply(cache[url]);
    fetch(url.split('?')[0] + '.js').then(function(r){ return r.json(); }).then(function(p){ cache[url] = p; apply(p); }).catch(function(){ window.location.href = url; });
  }
  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var t = e.target.closest('.tlc-qs-trigger');
    if (t) {
      lastCard = t.closest('product-block');
      var isFinal = !!(lastCard && (lastCard.querySelector('.tlc-badge--final') || lastCard.querySelector('.tcs__s.is-on[data-final]')));
      setTimeout(function(){ fill(lastCard, t.dataset.productUrl); finalNote(isFinal); }, 0);
      return;
    }
    var d = e.target.closest('#tlc-qs-colours .tcs__s');
    if (d) { e.preventDefault(); if (!d.classList.contains('is-on') && d.dataset.url) swap(d); return; }
    var c = e.target.closest('.tcs .tcs__s, .tcs .tcs__more');
    if (c && c.dataset.url && !c.classList.contains('is-on')) { e.preventDefault(); window.location.href = c.dataset.url; }
  }, true);
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var c = e.target.closest && e.target.closest('.tcs [role="link"]');
    if (c && c.dataset.url) { e.preventDefault(); window.location.href = c.dataset.url; }
  });
})();
